import { Checkbox, MenuItem, TextField, TextFieldProps } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    name: string;
    options: string[];
    required?: boolean;
    [props: string]: any;
}

const SelectWrapper = ({ name, options, required = false, ...props }: Props) => {
    const { setFieldValue } = useFormikContext();
    const [field, meta] = useField(name);
    const { t } = useTranslation();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        setFieldValue(name, value);
        setFieldValue(name, typeof value === 'string' ? value.split(',') : value);
    };

    const children = (): React.ReactNode => {
        const kantoren = options.filter(a => a === 'Alle kantoren')[0];
        const temp = options.filter(a => a !== 'Alle kantoren').sort((a, b) => a.localeCompare(b));
        if (kantoren !== undefined) temp.push(kantoren)
        return Object.keys(temp).map((option: string, i) => {
            const index = parseInt(option);
            return (
            <MenuItem key={i} value={temp[index]}>
                <Checkbox checked={field.value.indexOf(temp[index]) > -1} />
                {temp[index]}
            </MenuItem>
        )})
    }

    const configSelect: TextFieldProps = {
        ...field,
        ...props,
        required: required,
        select: true,
        variant: 'outlined',
        fullWidth: true,
        onChange: handleChange,
        SelectProps: {
            native: false,
            multiple: true,
            renderValue: (value: any) => {
                const converted: string[] = [];
                value.forEach((item: string) => {
                    converted.push(item);
                });
                return converted.join(', ');
            },
        },
        children: children(),
    };

    if (meta && meta.touched && meta.error) {
        configSelect.error = true;
        configSelect.helperText = t(meta.error);
    }

    return (
        <TextField {...configSelect} value={field.value ? field.value : []} />
    );
};

export default SelectWrapper;
